import { CategoryResponse, getGiftCardGetCategory } from "api"
import SeoMetaData from "common/SeoMetaData"
import SiteMapPage from "components/SiteMap/SiteMapPage"
import { GetStaticProps } from "next"

type HomeStaticProps = {
  categories: CategoryResponse[]
}

export const getStaticProps: GetStaticProps<HomeStaticProps> = async () => {
  const [category] = await Promise.all([await getGiftCardGetCategory()])

  return {
    props: { categories: category.data.body },
    revalidate: 60,
  }
}

const SiteMap = ({ categories }: HomeStaticProps) => {
  const seo = {
    title: "מפת אתר גיפטקארד מקדונלד'ס",
    description: "מפת אתר גיפטקארד מקדונלד'ס",
    keywords: "מפת אתר, sitemap, מפה, מפת האתר",
  }

  return (
    <>
      <SeoMetaData data={seo} />
      <SiteMapPage categories={categories} />
    </>
  )
}

export default SiteMap
